import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b31218e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-edit" }
const _hoisted_2 = { class: "form-item__left" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "flex1 text-ellipsis" }
const _hoisted_5 = { class: "perm-panel" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "select-radio_des" }
const _hoisted_8 = {
  key: 1,
  class: "divider divider_fir"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider divider_sec" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "flex1 text-ellipsis" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "change-btn" }, "更改", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "flex1 text-ellipsis" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "change-btn" }, "更改", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 关闭 ")


const __default__ = {
  name: 'Entry'
}

import { ref, computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  NForm,
  NFormItem,
  NTree,
  NRadio,
  useMessage,
  PopoverInst
} from 'naive-ui'
import type { FormInst } from 'naive-ui'
import { useAppDialog } from '@/components/appDialog'
import { Nav } from '@teams/common/models'
import useAddOrUpdateNav, {
  DEFAULT_ICON_MAP
} from '@teams/common/hooks/useAddOrUpdateNav'
import SelectFolderInsideGroup from './selectFolderInsideGroup.vue'
import Icon from '@teams/common/components/icon'
import CreateFileName from './createFileName.vue'
import EntryNewNav from './entryNewNav.vue'
import { EnumNavKind, NavPermType } from '@teams/common/api/nav/types'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    initialValue: null
  },
  emits: ["close", "done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialValue?: Nav
}





const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.navigator.addOrUpdateNav.${key}`, ...params)
}

const dialog = useAppDialog()
const message = useMessage()

const { initialValue } = toRefs(props)

const {
  parentVisibleNames,
  visibleGroupOrRoleNames,
  roleTreeNodes,
  form,
  navInfo,
  navInstance,
  selectedViewInfo,
  updateView,
  navUpdateType,
  setSubPermInheritParent
} = useAddOrUpdateNav({ initialValue: initialValue?.value })

const formRef = ref<FormInst>()
const nameOption = computed(() => {
  return {
    defaultIcon: DEFAULT_ICON_MAP[navInfo.value.type],
    defaultName:
      navInstance.value.type === EnumNavKind.updates
        ? '最近更新'
        : navInfo.value.selectedFile?.name,
    icon: form.icon,
    name: form.name,
    autoUpdate: form.autoUpdate
  }
})
const roleNames = computed(() => {
  return visibleGroupOrRoleNames.value || $tt('navPermissionRequired')
})

const updateName = params => {
  const { autoUpdate, icon, name } = params
  const data = {
    auto_update: autoUpdate,
    icon,
    name
  }
  Object.keys(data).forEach(key => {
    if (data[key] === undefined) {
      delete data[key]
    }
  })
  updateView(data)
}

const setViewableRoleIds = (keys: number[]) => {
  form.viewableRoleIds = keys
}

const handleChange = (e: Event) => {
  const value = (e.target as HTMLInputElement).value
  form.customPerms = value === 'custom'
}
// 更改单文件
const changeFile = () => {
  dialog.show({
    title: '选择标签页视图',
    component: EntryNewNav,
    componentProps: {
      hideNameInput: true
    },
    modalStyle: {
      width: '640px',
      padding: '28px 32px'
    },
    componentEvents: {
      updateType: async context => {
        dialog.back()
        try {
          await updateView({
            kind: context.navType,
            finder: context.finder
          })
        } catch (e) {}
      }
    },
    footer: false
  })
}
// 更改文件夹
const changeFolder = () => {
  dialog.show({
    title: '选择目录',
    component: SelectFolderInsideGroup,
    componentEvents: {
      confirm: async context => {
        await updateView({
          finder: context.finder
        })
      }
    },
    footer: false
  })
}
// 监听popover显示标记选中背景状态
const popoverShowFlag = ref(false)
// 权限下拉菜单收起/展开
const handlePopoverUpdate = show => {
  popoverShowFlag.value = show
  if (show) {
    return
  }
  // 收起时判断权限有无发生变化，有变化更新标签信息
  navUpdateType.value !== NavPermType.UnChanged && updateView({})
}
const popoverRef = ref<PopoverInst>()
//  应用到子标签
const handleApplyToSubNav = async () => {
  await setSubPermInheritParent()
  message.success('应用成功，子标签页已继承当前页面的权限')
  popoverRef.value?.setShow(false)
  popoverShowFlag.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NForm), {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(form)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NFormItem), { path: "name" }, {
          default: _withCtx(() => [
            _createVNode(CreateFileName, {
              class: "nav-edit__name-input",
              nameOption: _unref(nameOption),
              onUpdate: updateName
            }, null, 8, ["nameOption"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NFormItem), { path: "viewableRoleIds" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_popover, {
              trigger: "click",
              placement: "bottom-end",
              "show-arrow": false,
              class: "popover__perm",
              "onUpdate:show": handlePopoverUpdate,
              ref_key: "popoverRef",
              ref: popoverRef
            }, {
              trigger: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-item", popoverShowFlag.value ? 'form-item__click' : ''])
                }, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString($tt('navPermissionLabel')), 1),
                  _createElementVNode("div", {
                    class: "form-item__perm",
                    title: _unref(roleNames)
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(roleNames)), 1),
                    _createVNode(_unref(Icon), {
                      name: "arrowDownPerm",
                      size: 16
                    })
                  ], 8, _hoisted_3)
                ], 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_n_space, {
                    vertical: "",
                    class: "role-wrapper"
                  }, {
                    default: _withCtx(() => [
                      (!_unref(navInfo).isRoot)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["select-radio", !_unref(form).customPerms ? 'popover-select' : '']),
                            title: _unref(parentVisibleNames)
                          }, [
                            _createVNode(_unref(NRadio), {
                              checked: !_unref(form).customPerms,
                              value: "inherit",
                              name: "perms",
                              onChange: handleChange
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(!_unref(form).customPerms ? 'select-radio_name' : '')
                                }, " 继承上级标签页 ", 2),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(parentVisibleNames)), 1)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ], 10, _hoisted_6))
                        : _createCommentVNode("", true),
                      (!_unref(navInfo).isRoot)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                        : _createCommentVNode("", true),
                      (!_unref(navInfo).isRoot)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["select-radio_special", _unref(form).customPerms ? 'popover-select' : ''])
                          }, [
                            _createVNode(_unref(NRadio), {
                              checked: _unref(form).customPerms,
                              value: "custom",
                              name: "perms",
                              onChange: handleChange
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_unref(form).customPerms ? 'select-radio_name' : '')
                                }, " 自定义 ", 2)
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_unref(navInfo).isRoot || (!_unref(navInfo).isRoot && _unref(form).customPerms))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(NTree), {
                              "block-line": "",
                              selectable: "",
                              checkable: "",
                              cascade: "",
                              "check-on-click": "",
                              "check-strategy": "child",
                              data: _unref(roleTreeNodes),
                              "checked-keys": _unref(form).viewableRoleIds,
                              "on-update:checked-keys": setViewableRoleIds,
                              "expand-on-click": false,
                              "default-expand-all": true
                            }, null, 8, ["data", "checked-keys"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_unref(navInfo).isLeaf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", {
                              class: "select-radio_text",
                              onClick: handleApplyToSubNav
                            }, " 同时应用到子标签页 ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _hoisted_12,
        _createVNode(_unref(NFormItem), {
          path: "navType",
          label: "标签页视图"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "form-item",
              onClick: changeFile
            }, [
              _createElementVNode("div", {
                class: "form-item__left form-item__icon-text",
                title: _unref(selectedViewInfo).name
              }, [
                (_openBlock(), _createBlock(_unref(Icon), {
                  key: _unref(selectedViewInfo).icon,
                  name: _unref(selectedViewInfo).icon,
                  size: 16,
                  fill: "transparent",
                  class: "form-item__icon"
                }, null, 8, ["name"])),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(selectedViewInfo).name), 1)
              ], 8, _hoisted_13),
              _hoisted_15
            ])
          ]),
          _: 1
        }),
        (!_unref(navInfo).isFile && _unref(selectedViewInfo).name)
          ? (_openBlock(), _createBlock(_unref(NFormItem), {
              key: 0,
              path: "navType",
              label: "视图对应的文件夹"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "form-item",
                  onClick: changeFolder
                }, [
                  _createElementVNode("div", {
                    class: "form-item__left form-item__icon-text",
                    title: _unref(selectedViewInfo).name
                  }, [
                    (_openBlock(), _createBlock(_unref(Icon), {
                      key: _unref(navInfo).selectedFile.icon,
                      name: _unref(navInfo).selectedFile.icon,
                      size: 16,
                      fill: "transparent",
                      class: "form-item__icon"
                    }, null, 8, ["name"])),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(navInfo).selectedFile.folderPath), 1)
                  ], 8, _hoisted_16),
                  _hoisted_18
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_n_space, {
      class: "content-bottom",
      size: 12,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})